import { gql } from 'apollo-angular';

const REFRESH_APTITUDE_TOKEN = gql`
  mutation RefreshAptitudeToken($aptitudeToken: String!) {
    refreshAptitudeToken(input: { aptitudeToken: $aptitudeToken }) {
      token
    }
  }
`;

interface AuthenticationResponse {
  accountInformation: {
    accountStatus: string;
  };
  mustAcceptTermsOfUse: boolean;
  token: string;
  username: string;
}

export default REFRESH_APTITUDE_TOKEN;
